import { Injectable } from '@angular/core';
import { OpenApiRemoteMethod, RxapOpenApiRemoteMethod } from 'eurogard-open-api-remote-method';
import { DeviceInboxRegistrationTokenControllerGenerateTokenResponse } from '../responses/device-inbox-registration-token-controller-generate-token.response';

@Injectable({
    providedIn: 'root'
  })
@RxapOpenApiRemoteMethod({
    serverId: 'legacy',
    operationId: 'device-inbox-registration-token-controller-generateToken',
    operation: '{"operationId":"device-inbox-registration-token-controller-generateToken","responses":{"200":{"content":{"application/json":{"schema":{"type":"object","properties":{"uuid":{"type":"string","format":"uuid"},"registrationToken":{"type":"string"},"user":{"$ref":"#/components/schemas/User"},"expiresAt":{"type":"integer","format":"int64"}}}}}}},"method":"post","path":"/device-inbox-regtoken-controller/generate"}'
  })
export class DeviceInboxRegistrationTokenControllerGenerateTokenRemoteMethod extends OpenApiRemoteMethod<DeviceInboxRegistrationTokenControllerGenerateTokenResponse, void, void> {
  public override call(): Promise<DeviceInboxRegistrationTokenControllerGenerateTokenResponse> {
    return super.call();
  }
}
